import { SALES_API_BASE_URL } from "app/pages/sales-intelligence/constants/api";
import type { IndustryTaxonomyDto } from "app/pages/sales-intelligence/domain/industry/types/taxonomy";
import type { CrmJobsTransitionDto } from "app/pages/sales-intelligence/modules/industry/types/crmJobsTransition";
import type { IndustryTransitionImpactReportDto } from "app/pages/sales-intelligence/modules/industry/types/impactReport";
import type { GetRequestOptions, IFetchService } from "app/services/fetchService";

const TRANSITION_BASE_URL = `${SALES_API_BASE_URL}/industry-taxonomy-transition`;

const createIndustryApiService = (fetchService: IFetchService) => {
    return {
        fetchTaxonomy(options?: Readonly<GetRequestOptions>): Promise<IndustryTaxonomyDto> {
            return fetchService.get("/sales-api/industry-taxonomy/description", undefined, options);
        },

        fetchImpactReport(options?: Readonly<GetRequestOptions>): Promise<IndustryTransitionImpactReportDto> {
            return fetchService.get(`${TRANSITION_BASE_URL}/impact-report`, undefined, options);
        },

        fetchCrmJobsTransition(options?: Readonly<GetRequestOptions>): Promise<CrmJobsTransitionDto> {
            return fetchService.get(`${TRANSITION_BASE_URL}/crm-jobs`, undefined, options);
        },

        sendContactEmail(options?: Readonly<GetRequestOptions>): Promise<void> {
            return fetchService.get(`${TRANSITION_BASE_URL}/send-email`, undefined, options);
        },

        /**
         * Rewrites every account asset referencing the legacy industry filter, then flips the account
         * flag and the caller's opt-in setting. Not idempotent.
         */
        enroll(): Promise<void> {
            return fetchService.put(`${TRANSITION_BASE_URL}/enroll`);
        },
    };
};

export default createIndustryApiService;
